import { Space } from 'antd'
import { Report } from '@cims-online/shared'
import { ReportValue } from '../types'
import { WithColumn } from './types'
import CIMSLink from '../../CIMSLink'

const ReportCustomFields: React.FC<
  WithColumn<Pick<ReportValue, 'customFieldId' | 'reports'>>
> = ({ customFieldId, reports = [], column }) => {
  return (
    <Space
      key={`${customFieldId}_reports`}
      size="small"
      direction={column ? 'vertical' : undefined}
    >
      {reports.map(({ reportId, label, href }) => {
        const { name } = Report.fromIdOrFail(reportId)
        return (
          <CIMSLink
            key={`${customFieldId}_${reportId}`}
            external
            tooltip={
              !href ? `There is no recordId associated with ${name}` : name
            }
            href={href}
          >
            {label}
          </CIMSLink>
        )
      })}
    </Space>
  )
}

export default ReportCustomFields
